<h1>Invia messaggio all'assistenza</h1>
<div class="form-container">
  <form class="details-form" [formGroup]="userForm">
    <mat-form-field class="full-width">
      <mat-label>Mittente</mat-label>
      <input matInput placeholder="Mittente" formControlName="email" name="email" type="email" pattern="([A-Za-z0-9][._]?)+[A-Za-z0-9]@[A-Za-z0-9]+(\.?[A-Za-z0-9]){2}\.(com?|net|org)+(\.[A-Za-z0-9]{2,4})?" required>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>Messaggio</mat-label>
      <textarea rows="5" matInput placeholder="Messaggio" name="messaggio"
                formControlName="messaggio"></textarea>
    </mat-form-field>
    <button mat-fab extended   class="searchbox-buttons save-button" (click)="fileInput.click()">
      <mat-icon> attach_file</mat-icon>Allega
      <input #fileInput type="file" (change)="onFileSelected($event)" style="display:none;" />
    </button>
    <p class="decreto" *ngFor="let file of data.allegati">
      {{file.name}}
    </p>
  </form>
</div>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Annulla
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" [mat-dialog-close]="data" (click)="send()" [disabled]="userForm.get('email').hasError('email') || userForm.get('email').hasError('required')" >
    <mat-icon>send</mat-icon>Invia
  </button>
</div>
